import React from 'react';

// The Checkout Page mark: the slanted card with the notch cut out as an
// even-odd hole so it inherits `currentColor` and adapts to any background.
// `size` drives the height; width follows the mark's natural 155:84 ratio.
const Logo = ({ size = 40 }) => {
  return (
    <svg
      height={size}
      width={Math.round((size * 155) / 84)}
      viewBox="0 0 155 84"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      xmlns="http://www.w3.org/2000/svg"
      className="inline-block"
      aria-hidden="true"
    >
      <path d="M19 0 L155 0 L136 84 L0 84 Z M30 13 L50 13 L47 26.5 L27 26.5 Z" />
    </svg>
  );
};

export default Logo;
